import { Injectable, inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { DashboardWidgetType } from '@platform/dashboard/enums/dashboard-news-banner-type.enum';
import { selectDashboardWidgets } from '@platform/dashboard/pages/dashboard/dashboard.selectors';
import { selectIsLoadingPortfolio } from '@platform/portfolio/selectors/portfolio.selectors';
import { map } from 'rxjs';

@Injectable()
export class DashboardComponentStore extends ComponentStore<null> {
  private readonly globalStore = inject(Store);

  constructor() {
    super(null);
  }

  // SELECTORS ---------------------------------------------------------------------------------------------------------
  readonly selectIsLoadingPortfolio$ = this.globalStore.select(selectIsLoadingPortfolio);
  readonly selectDashboardWidgets$ = this.globalStore.select(selectDashboardWidgets);
  readonly hasWidgetBetterDeal$ = this.selectDashboardWidgets$.pipe(
    map((widgets) => widgets.some((widget) => widget.type === DashboardWidgetType.HAS_DEAL)),
  );

  // ACTIONS -----------------------------------------------------------------------------------------------------------
}
